import React from 'react'
import { Button } from 'react-bootstrap'

interface SeatRequiredModalProps {
  ownerEmail: string
  onContinue?: () => void
}

export default function SeatRequiredModal({ ownerEmail, onContinue }: SeatRequiredModalProps) {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
      }}
    >
      <div
        style={{
          maxWidth: 480,
          padding: 32,
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
          textAlign: 'center',
        }}
      >
        <h4 style={{ marginBottom: 16 }}>Seat Required</h4>
        <p style={{ color: '#6c757d', marginBottom: 8 }}>
          You need a seat assignment to access PayHelm.
        </p>
        <p style={{ color: '#6c757d', marginBottom: 24 }}>
          Please contact your admin (<strong>{ownerEmail}</strong>) to assign you a seat.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <Button variant="primary" onClick={handleRefresh}>
            Refresh
          </Button>
          {onContinue && (
            <Button variant="outline-secondary" onClick={onContinue}>
              Continue
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
